<template>
  <!-- Booking Confirmation -->
  <div class="report-main" :style="{ backgroundColor: backgroundColor }" >
    <div style="width:100%;height:100%"> 
        <div class="booking-con-main">
          <div class="booking-con-left">
            <b>Booking Confirmation Letter</b>
            <button style="text-align:left;" @click="displayForm()">Document / Notice / Letter Info<img src="https://img.icons8.com/material-sharp/12/000000/give-way--v1.png" style="float:right;"></button>
            <div v-if="this.menu1Clicked==false" class="booking-form-section">
              <!-- Header Info -->
              <div class="booking-tab-block">
                <div class="booking-tab-title">Header</div>
                <div class="booking-tab-content">
                <div class="booking-details">
                  <DateTimePicker title="Date" placeholder="Date" :showTime="true" :value.sync="currentDateTime"/>
                  </div>
                <div class="booking-details">
                  <Input placeholder="To" :inputValue.sync="to"/>
                  <Input placeholder="Attn" :inputValue.sync="attn" style="margin-left:5px;"/>
                </div>
                <div class="booking-details">
                  <Input placeholder="Tel" :inputValue.sync="tel"/>
                  <Input placeholder="Fax" :inputValue.sync="fax" style="margin-left:5px;"/>
                </div>
                <div class="booking-details">
                  <CheckBox title="Show company letter head" :isChecked.sync="letterHead" style="margin-left:5px;" />
                </div>
                </div>
              </div>
              <!-- Middle Section: not needed in booking confirmation
              <div class="booking-tab-content">
                <div class="booking-details">
                  <Dropdown placeholder="Operation Code"/>
                  <Input placeholder="Carrier Code" style="margin-left:5px;"/>
                  <Input placeholder="Carrier Agent" style="margin-left:5px;"/>
                </div>
              </div>--> 
              <!-- Footer Info -->
              <div class="booking-tab-block">
                <div class="booking-tab-title">Footer</div>
                <div class="booking-tab-content">
                  <div class="booking-details">
                  <RemarksBox title="Remarks" :text.sync="inputRemarks" style="height: 120px;" :freeText="true" />
                </div>
                <div class="booking-details">
                  <RemarksBox title="Regards" :text.sync="Regards" style="height: 217px;width:50%" :freeText="true" />
                  <div class="booking-signature-form">
                    Signature
                    <button v-if="editSigClicked==false" class="booking-signature-button" @click="editSignature">Edit</button>
                    <button v-else class="booking-signature-button" @click="editSignature">Back</button>
                    <div class="booking-details-remarks">
                      <div v-if="editSigClicked==false">
                        <div v-if="this.currentUserOptions[this.currentUserOptions.setDefaultSignature]">
                        <img v-bind:src="this.currentUserOptions[this.currentUserOptions.setDefaultSignature]" class="signature-preview" />
                        </div>
                        <div v-else class="signature-preview signature-preview-no">No signature found</div>
                      </div>
                      <div v-else class="signature-another">
                        Choose another signature
                         <div class="default-signature">
                        Signature 1<button class="default-select-button" @click="defaultSignatureSelect(1)">Select</button>
                        </div>
                        <div class="default-signature">
                        Signature 2<button class="default-select-button" @click="defaultSignatureSelect(2)">Select</button>
                        </div>
                        <div class="default-signature">
                        Signature 3<button class="default-select-button" @click="defaultSignatureSelect(3)">Select</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              </div>
            <button style="text-align:left;margin-top:10px;" disabled>Job Filtering<img src="https://img.icons8.com/material-sharp/24/000000/give-way--v1.png" style="width:12px;float:right;"></button>
          </div>
          <div class="booking-con-right">
            <div class="booking-con-top">
            <Input textAlign="center" placeholder="Job No" :inputValue.sync="jobno" @enter="pdfClicked" class="booking-job-no"/>
            <button @click="pdfClicked"><img src="https://img.icons8.com/ios-glyphs/18/000000/refresh--v1.png"> Preview Report</button>
            <button @click="printBookingConfirmation" style="margin-left:5px;"><img src="https://img.icons8.com/android/15/000000/print.png"> Print</button>
            <button @click="sharePopup" style="margin-left:5px;"><img src="https://img.icons8.com/material-outlined/18/000000/share.png"> Share</button>
            </div>
            <!-- Share Booking Confirmation Popup -->
            <div v-if="shareFilePopup" class="share-selection">
            <div class="share-popup-title" style="padding:10px;">
              <img src="https://img.icons8.com/dusk/90/000000/share-2.png"/><br />
              Share
            </div>
            <div class="share-popup-container">
              <button @click="emailShare" style="background:#505050;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/ios-glyphs/20/ffffff/filled-message.png"/> Email</button>
              <button @click="whatsappShare" style="background:#25D366;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/color/21/000000/whatsapp.png"/> WhatsApp</button>
              <button @click="telegramShare" style="background:#0088cc;color:#FFFFFF;margin:5px;width:115px;"><img src="https://img.icons8.com/color/20/000000/telegram-app.png"/> Telegram</button>
              <!-- Copy Link to Clipboard -->
              <div class="share-copy">
                <input type="text" :value="this.fileLink" id="copyBookingConfirmation" class="share-copy-holder">
                <button @click="copyingTheLink()"><img src="https://img.icons8.com/material-outlined/20/000000/copy.png"/></button>
              </div>
              <div class="copy-message">
                <div v-if="copyLink">
                  Copied to Clipboard
                </div>
              </div>
              <div class="share-cancel"> 
                  <button @click="sharePopup" style="margin:5px;">Cancel</button>
              </div>
            </div>
            </div>
            <Loader :isVisible.sync="loading" :loadingText="loadText" :isFullScreen="true" />
            <div class="error-message">{{ errorMessage }}</div>
            <div style="display:flex;background:white;width:100%;justify-content:flex-end;border-radius:3px;margin-top:10px;height:100%">
             <iframe v-if="pdfLink" :src="pdfLink" id="iframe" frameborder="0" style="width:100%;height:100%"></iframe>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import Input from '@/components/Input.vue';
import RemarksBox from '@/components/RemarksBox.vue';
export default {
  components: {
    Loader, Input, RemarksBox
  },
  data () {
    return {
      jobno: '',
      loading: false,
      loadText: '',
      errorMessage: '',
      pdfLink: '',
      menu1Clicked: false,
      editSigClicked: false,
      shareFilePopup: false,
      bookingBlob: "",
      letterHead: true,
      inputRemarks: "",
      Regards: "",
      fileLink: "Link Here",
      currentDateTime: new Date(),
      to: "",
      tel: "",
      attn: "",
      fax: "",
      bookingRefNo: "", 
      cusRefNo: "",
      copyLink: false,
    }
  },
  props: {
    currentUserOptions: {
      type: Object,
      default: function () {
        return {
          Signature1: "",
          Signature2: "",
          Signature3: "",
          setDefaultSignature: ""
        };
      },
    },
  },
  async mounted() {
    this.jobno = (this.$route.params.jobno) ? this.$route.params.jobno : '';
    if (this.jobno) { 
      this.loadText = "Getting Booking Details"
      this.loading  = true;
      await this.getSignatureDetails();
      await this.getFormDetails();
      this.pdfClicked();
      this.$bus.$on('backgroundColorChanged', (color) => {
      this.backgroundColor = color;
    });  
    }
  },
  methods: {
    pdfClicked: async function () {
      this.errorMessage = '';
      if (!this.jobno) {
        this.errorMessage = `Please enter your ${this.portName} No`;
        return;
      }
      this.loadText = 'Getting Report Details';
      this.loading = true;
      await this.getBookingConfirmation();  
      this.loading = false;
    },
    getBookingConfirmation: async function (){
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try {
      var jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&jobno=${this.jobno}`, loginDetails);
      } catch (e) {console.log(e);}
      if (jsDetails.data.length == 0) {
        this.loading = false;
        this.errorMessage = `Invalid Job No '${this.jobno}'.\nPlease enter a valid Job No`;
        return;
      }
      
      // Checkbox toggle to display letter head or not
      if (this.letterHead && loginDetails.CoHeaderOpr){
        jsDetails.data.JobDetails.Job['companyHeader'] = loginDetails.CoHeaderOpr;
      }
      else {
        jsDetails.data.JobDetails.Job['companyHeader'] = " ";
      }
      var bcdate = this.$dateTime.getDateTime(this.currentDateTime, 'dd-MM-yyyy');
      jsDetails.data.JobDetails.Job['BCDate'] = bcdate;
      jsDetails.data.JobDetails.Job['To'] = this.to;
      jsDetails.data.JobDetails.Job['Attn'] = this.attn;
      jsDetails.data.JobDetails.Job['Tel'] = this.tel;
      jsDetails.data.JobDetails.Job['Fax'] = this.fax;
      jsDetails.data.JobDetails.Job['inputRemarks'] = this.inputRemarks;
      jsDetails.data.JobDetails.Job['Regards'] = this.Regards;
      jsDetails.data.JobDetails.Job['Signature'] = this.currentUserOptions[this.currentUserOptions.setDefaultSignature];
      var jsReportData = {
        template: { shortid: 'j7o6kc7VmL' },
        data: jsDetails.data.JobDetails.Job,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };
      await this.getJSReportBookingPDF(jsReportData);
    },
     getJSReportBookingPDF: async function (data){
      this.loadText = 'Creating Report';
      const headerInfo = {
        'Content-Type': 'application/json',
        'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
      };
      try{
      var jsReportPDF = await this.$apiCallV2('https://dsm.logistics.systems:5488/api/report', data, { headers: headerInfo, responseType: 'arraybuffer' });
      
      var contentType = jsReportPDF.headers['content-type'];
      this.bookingBlob = new Blob([ jsReportPDF.data ], { type: contentType });
      var url = window.URL.createObjectURL(this.bookingBlob, { oneTimeOnly: false });
      var link = document.createElement('a');
      link.href = url;
      this.pdfLink = url;
      } catch(e){
        this.loading=false;
        this.errorMessage = 'There was an error while creating your report';
        console.log(e);
      }
    },
    uploadBookingConfirmation: async function (pdfBlob) {
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      var formData = new FormData();
      formData.append('file', pdfBlob, loginDetails.ConfigCode + "_" + loginDetails.LoginUserID + "_BCL_" + this.jobno + "_" + this.getFileNameDateTime() + ".pdf");
      formData.append('folder', loginDetails.ConfigCode);
      
      var bookingConfirmationLink = await this.$apiCallV2('/Upload/UploadFile', formData);
      if (bookingConfirmationLink){
        this.fileLink = bookingConfirmationLink['data'];
        console.log("Generate Link Success");
        console.log(bookingConfirmationLink['data']); //to get the link
      }
      else {
        this.fileLink = "Error Generating Link";
      } 
    },
    // date time format for the Booking Confirmation Letter upload file name 
    getFileNameDateTime: function () {
      var day = new Date();
      var dd = String(day.getDate()).padStart(2, '0');
      var mm = String(day.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = String(day.getFullYear());
      var hh = String(day.getHours()).padStart(2, '0');
      var nn = String(day.getMinutes()).padStart(2, '0');
      day = yyyy + mm + dd + hh + nn;
      return day;
    },
    displayForm: async function() {
      this.menu1Clicked = !this.menu1Clicked;
    },
    editSignature: async function() {
      this.editSigClicked = !this.editSigClicked;
    },
    printBookingConfirmation: async function() {
      try{
      setTimeout(() => {
        var frame = document.getElementById('iframe').contentWindow;
        frame.focus();
        frame.print();
      }, 100);
      } catch(e){
        this.loading=false;
        this.errorMessage = 'There was an error while creating your report';
        console.log(e);
      }
    },
    sharePopup: async function() {
      this.shareFilePopup = !this.shareFilePopup;
      if (this.shareFilePopup) {
        this.loadText = 'Generating Report Link';
        this.loading = true; 
        await this.uploadBookingConfirmation(this.bookingBlob);
        //document.getElementById("copyBookingConfirmation").value = this.fileLink;
        this.loading = false;
      }
    },
    emailShare: async function () {
      var subject = "Booking Confirmation Letter - Booking Ref # : " +this.bookingRefNo ;
      var body = "Your Ref # : " + this.cusRefNo + "%0D%0AOur Ref # : " + this.jobno + "%0D%0A" + this.fileLink;
      var url = "mailto:?subject=" + subject + "&body=" + body;
      window.location.href = url;
    },
    whatsappShare: async function () {
      var body = "Booking Confirmation Letter - Booking Ref : " + this.bookingRefNo + "%0D%0AYour Ref : " + this.cusRefNo + "%0D%0AOur Ref : " + this.jobno + "%0D%0A" + this.fileLink;
      var url = "https://wa.me/?text=" + body;
      window.open(url, '_blank'); 
    }, 
    telegramShare: async function () {
      var subject = "Booking Confirmation Letter - Booking Ref : " + this.bookingRefNo + "%0D%0A" ;
      var body = "Your Ref : " + this.cusRefNo + "%0D%0AOur Ref : " + this.jobno + "%0D%0A";
      var url = "https://t.me/share/url?url=" + subject + body + this.fileLink;
      window.open(url, '_blank');
    },
    defaultSignatureSelect: async function (signatureNum){
      if (signatureNum == 1){
        this.currentUserOptions.setDefaultSignature = 'Signature1';
        this.editSigClicked = !this.editSigClicked;
      }
      else if (signatureNum == 2){
        this.currentUserOptions.setDefaultSignature = 'Signature2';
        this.editSigClicked = !this.editSigClicked;
      }
      else {
        this.currentUserOptions.setDefaultSignature = 'Signature3';
        this.editSigClicked = !this.editSigClicked;
      }
    },
    getSignatureDetails: async function () {
      var userOptionsData = await this.$apiCallV2('/UserOptions/GetSettingsSystemUser?settings=UserOptions');
      if (userOptionsData.data[0].SettingsValue) {
        var userOptionsObj = JSON.parse(userOptionsData.data[0].SettingsValue);
        this.currentUserOptions.Signature1 = userOptionsObj.Signature1 ? userOptionsObj.Signature1 : "";
        this.savedSignature1 = userOptionsObj.Signature1;
        
        this.currentUserOptions.Signature2 = userOptionsObj.Signature2 ? userOptionsObj.Signature2 : "";
        this.savedSignature2 = userOptionsObj.Signature2;
        this.currentUserOptions.Signature3 = userOptionsObj.Signature3 ? userOptionsObj.Signature3 : "";
        this.savedSignature3 = userOptionsObj.Signature3;
        this.currentUserOptions.setDefaultSignature = userOptionsObj.setDefaultSignature;
        this.backgroundColor = userOptionsObj.BackgroundColor ? `#${userOptionsObj.BackgroundColor}` : '#E0ECF8';
          this.$bus.$emit('backColorChanged', this.backgroundColor);
        } else {
          this.backgroundColor = '#E0ECF8';
      }
    },
    getFormDetails: async function () {
      var loginDetails = await this.$apiCallV2('/Login/GetDetails');
      try {
      var jsDetails = await this.$apiCallV2(`/Report/GetJobDetails?config=${loginDetails.ConfigCode}&userID=${loginDetails.LoginUserID}&jobno=${this.jobno}`, loginDetails);
      } catch (e) {console.log(e);}
      if (jsDetails.data.length == 0) {
        this.loading = false;
        this.errorMessage = `Invalid Job No '${this.jobno}'.\nPlease enter a valid Job No`;
        return;
      }
       //Get the form defaults from get job detail and login detail
      this.to = jsDetails.data.JobDetails.Job['Shipper Name'];
      this.attn = jsDetails.data.JobDetails.Job['Cust Attn'];
      this.tel = jsDetails.data.JobDetails.Job['Cust Tel'];
      this.fax = jsDetails.data.JobDetails.Job['Cust Fax'];
      this.bookingRefNo = jsDetails.data.JobDetails.Job['Booking Ref No'];
      this.cusRefNo = jsDetails.data.JobDetails.Job['Cust Ref No'];
      this.Regards = loginDetails.UserName;
    },
    // function to copy the link to clipboard
    copyingTheLink: function () {
      var copyText = document.getElementById("copyBookingConfirmation");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      this.copyLink = true;
      setTimeout(() => {
              this.copyLink = false;
            }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.report-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  display: flex;
  font-size: 12px;
  flex-direction: column;
  align-items: center;
  > iframe {
    width: 100%;
    height: 100%;
  }
  > .error-message {
    color: red;
    width: 100%;
    text-align: center;
    margin-top: 5px;
    white-space: pre-wrap;
  }
}
.booking-tab-block {
  display: flex;
  width: 99%;
  border: 1px solid rgba(0,0,0,0.5);
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-radius: 3px;
  > .booking-tab-title {
    width: fit-content;
    background-color: white;
    position: absolute;
    top: -10px;
    left: 10px;
    padding: 0 10px;
  }
}
.booking-details {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.booking-details-remarks {
  border: 1px solid rgb(200,200,200);
  border-radius: 3px;
  width: 100%;
  height: 200px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 5px;
  padding-right: 5px;
}
.share-selection {
    position: fixed;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > .share-popup-container {
      background-color: white;
      width: 100%;
      max-width: 30%;
      max-height: 60%;
      padding: 10px;
      overflow: auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    > .share-popup-title {
      width: 100%;
      max-width: 30%;
      background-color: white;
      padding: 10px 0;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
    }
}
.signature-preview {
  max-height: 200px;
  max-width: 100%;
}
.default-signature {
  margin-top: 8px;
}
.default-select-button {
  float: right;
  padding: 2px 5px;
}
.share-copy {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  padding-top: 10px;
}
.share-copy-holder {
  width: 100%;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid rgb(200,200,200);
}
.copy-message {
  width: 100%;
  min-height: 20px;
  display: flex;
}
.share-cancel {
  width: 100%;
  display: flex;
  justify-content: center;
}
.booking-con-main {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
}
.booking-con-left {
  display: flex;
  background: white;
  width: 30%;
  height: calc(100%);
  padding: 10px;
  flex-direction: column;
  border-radius: 3px;
  flex-grow: 1;
  padding-top: 35px;
}
.booking-form-section {
  width: 100%;
  height: 100%;
  overflow: auto;
  margin-top: 10px;
}
.booking-tab-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.booking-signature-form {
  flex-direction: column;
  width: 50%;
  margin-left: 5px;
  margin-top: 3px;
}
.booking-signature-button {
  height: auto;
  padding: 0px 5px;
  float: right;
}
.signature-preview-no {
  min-height: 200px;
  text-align: center;
}
.signature-another {
  width: 100%;
  margin-top: 5px;
}
.booking-con-right {
  display: flex;
  margin-left: 10px;
  width: 50%;
  flex-direction: column;
  flex-grow: 1;
}
.booking-con-top {
  display: flex;
  background: white;
  width: 100%;
  padding: 10px;
  justify-content: flex-end;
  border-radius: 3px;
}
.booking-job-no {
  margin-right: 10px;
  flex: 1;
}
</style>